import { createElement } from 'react';
import { ICONS, ICON_STROKE, resolveIcon, type IconAlias, type IconName } from './icons';

export type { IconName } from './icons';

/**
 * Biểu tượng SVG nét 24×24 dựng từ dữ liệu `icons.ts` (nguồn duy nhất, xem quy cách ở đó). Dựng bằng `createElement`
 * nên không dùng innerHTML. Biểu tượng chỉ để trang trí (`aria-hidden`); nút chứa nó phải có `aria-label`
 * (xem IconButton). Tên lạ rơi về `chat` để giao diện không vỡ.
 */
export function Icon({ name, size = 20 }: { name: IconName | IconAlias | (string & {}); size?: number }) {
  const elements = resolveIcon(name) ?? ICONS.chat;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={ICON_STROKE}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {elements.map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs }))}
    </svg>
  );
}
